// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { assetsTypeSlice } from '@shared/data-access/slices';
import { resetAvailableParameters } from '@advisor-app/store/slices/available-parameters';
import { resetCopilot } from '@advisor-app/store/slices/copilot-buffer';
import { resetParameters } from '@advisor-app/store/slices/parameters';
import {
  resetSavedPortfolios,
  resetScreeners,
} from '@advisor-app/store/slices/my-research';
import { tagManagerSlice } from '@shared/data-access/slices/tag-manager';
import { useAppDispatch } from '@advisor-app/store/store';

const EXCLUDED_PATHS = [
  '/asset-allocation/positions',
  '/analysis/stock/positions',
  '/analysis/etf/positions',
  '/analysis/mutual-fund/positions',
  '/rebalance/configuration',
  '/rebalance/summary',
];

export const useResetAppStore = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetAvailableParameters());
    dispatch(tagManagerSlice.actions.resetTagManager());
    dispatch(assetsTypeSlice.actions.resetAssetType());
    dispatch(tagManagerSlice.actions.resetWatchlist());
    dispatch(resetSavedPortfolios());
    dispatch(resetScreeners());
    dispatch(resetCopilot());

    if (!EXCLUDED_PATHS.includes(pathname)) {
      dispatch(resetParameters());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
